import { Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'app-nav-button-menu',
    templateUrl: './nav-button-menu.component.html',
    styleUrls: ['./nav-button-menu.component.scss'],
    imports: [MatButton, RouterLinkActive, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, RouterLink]
})
export class NavButtonMenuComponent {
  @Input() buttonName: string | undefined;
  @Input() menuOptions: NavOption[] | undefined;

  constructor() { }

  trackByNavOption(_index: number, option: NavOption): string {
    const sub = option.subOptions?.map((s) => s.route).join(',') ?? '';
    return `${option.name}|${option.route}|${sub}`;
  }

  trackBySubOption(_index: number, sub: NavOption): string {
    return `${sub.name}|${sub.route}`;
  }
}

export interface NavOption{
  name: string;
  route: string;
  subOptions?: NavOption[];
}

